var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopsign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_406_1",
    "data-name": "Component 406 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655",
    transform: "translate(-1118 -249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z",
    transform: "translate(1118 249)",
    fill: "#575b64"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Warning_Stop_Sign",
    "data-name": "Warning / Stop_Sign",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.222,4.222,9.778,9.778M7,11a4,4,0,1,1,4-4A4,4,0,0,1,7,11Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopsign);
export default __webpack_public_path__ + "static/media/stopsign.e29b081e66800277448a74bb420ff377.svg";
export { ForwardRef as ReactComponent };